<template>
  <div class="app" @scroll="scrollTop()">
  </div>
</template>

<script>
export default {
  name: 'bottom',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/gyl/bottom.vue